// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/filter'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less';
import './http'
import VueWechatTitle from 'vue-wechat-title'
import InfiniteScroll from 'vue-infinite-scroll';

Vue.use(VueWechatTitle)

Vue.use(Antd)
Vue.use(InfiniteScroll)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js